import { useState } from 'react';

/**
 * Chrome del card de auth (Login + Password reset).
 * Renderiza el wordmark Icaria, la caption "CheckIn · Internal", el subtítulo,
 * el slot del formulario y el slot del link meta inferior.
 */
export function AuthCard({
  subtitle,
  children,
  meta,
}: {
  subtitle: string;
  children: React.ReactNode;
  meta?: React.ReactNode;
}) {
  return (
    <div className="bg-card rounded-sm p-14 shadow-auth">
      <div className="flex justify-center mb-2.5">
        <div className="flex items-baseline gap-2.5">
          <span className="text-[34px] font-bold tracking-[0.16em] text-foreground leading-none">
            ICARIA
          </span>
          <span className="font-mono text-[12px] font-medium uppercase tracking-[0.18em] text-muted-foreground leading-none">
            ATELIER
          </span>
        </div>
      </div>
      <p
        className="text-center font-mono text-[12px] font-medium uppercase text-muted-foreground mb-5"
        style={{ letterSpacing: '0.14em' }}
      >
        CheckIn · Internal
      </p>
      <p className="text-center text-[15px] text-muted-foreground mb-9">{subtitle}</p>

      {children}

      {meta ? <div className="mt-5 text-center">{meta}</div> : null}
    </div>
  );
}

/** Botón primario azul Icaria con hover via React state (sortea CSS hover roto en algunos entornos). */
export function PrimaryAuthButton({
  submitting,
  children,
}: {
  submitting?: boolean;
  children: React.ReactNode;
}) {
  const [hovered, setHovered] = useState(false);
  const colors = hovered
    ? { bg: '#0E1480', border: '#0E1480' } // icaria-700 (deep)
    : { bg: '#1B23B8', border: '#1B23B8' }; // icaria-600

  return (
    <button
      type="submit"
      disabled={submitting}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        backgroundColor: colors.bg,
        borderColor: colors.border,
        color: '#F5F5F4',
        transition: 'background-color 150ms, border-color 150ms',
      }}
      className="w-full inline-flex items-center justify-center gap-2 h-14 px-5 rounded-sm border font-medium text-base disabled:opacity-50 disabled:pointer-events-none active:translate-y-px"
    >
      {children}
    </button>
  );
}
